import React, { createContext, FC } from 'react';
import {
  ClientDepartmentStatusList,
  ClientLocationStatusList,
  GroupColorMap,
  GroupIconMap,
  useGetClientDepartmentsByStatusQuery,
  useGetClientLocationsByStatusQuery,
  useGetGroupColorsQuery,
  useGetGroupIconsQuery,
} from 'api';
import { useNotify } from 'hooks';

export interface IGroupData {
  clientDepartments: ClientDepartmentStatusList;
  clientLocations: ClientLocationStatusList;
  groupIcons: GroupIconMap[];
  groupColors: GroupColorMap[];
  isLoading: boolean;
}

const GroupDataContext = createContext<IGroupData>({
  clientDepartments: null,
  clientLocations: null,
  groupIcons: [],
  groupColors: [],
  isLoading: false,
});

const GroupDataProvider: FC = ({ children }) => {
  const notify = useNotify();

  const departmentsOptions = useGetClientDepartmentsByStatusQuery({
    fetchPolicy: 'network-only',
    onError: notify.queryError,
  });

  const locationsOptions = useGetClientLocationsByStatusQuery({
    fetchPolicy: 'network-only',
    onError: notify.queryError,
  });

  const iconsOptions = useGetGroupIconsQuery({
    fetchPolicy: 'network-only',
    onError: notify.queryError,
  });

  const colorsOptions = useGetGroupColorsQuery({
    fetchPolicy: 'network-only',
    onError: notify.queryError,
  });

  const values = {
    clientDepartments: departmentsOptions.data?.getClientDepartmentsByStatus || {
      client_departments: [],
      count: 0,
      paginate: false,
    },
    clientLocations: locationsOptions.data?.getClientLocationsByStatus || {
      client_locations: [],
      count: 0,
      paginate: false,
    },
    groupIcons: iconsOptions.data?.getGroupIcons || [],
    groupColors: colorsOptions.data?.getGroupColors || [],
    isLoading:
      departmentsOptions.loading ||
      locationsOptions.loading ||
      iconsOptions.loading ||
      colorsOptions.loading,
  };

  return <GroupDataContext.Provider value={values}>{children}</GroupDataContext.Provider>;
};

export { GroupDataContext, GroupDataProvider };
